import { CacheProvider } from '@emotion/react';
import { Direction } from '@mui/material';
import React from 'react';
import { PropsWithChildren } from 'react';
import { cacheLtr, cacheRtl } from './cache/direction';

export type RTLCacheProviderProps = {
	direction: Direction;
};
export function RTLCacheProvider({ direction, children }: PropsWithChildren<RTLCacheProviderProps>): JSX.Element {
	return <CacheProvider value={direction == 'rtl' ? cacheRtl : cacheLtr}>{children}</CacheProvider>;
}
